/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `not_enough_availability` - Not enough availability
 * * `provider_does_not_meet_criteria` - Provider does not meet criteria
 * * `the_need_has_been_filled_by_another_provider` - The need has been filled by another provider
 * * `rate_is_too_high` - Rate is too high
 * * `other` - Other
 */
export enum FacilityRejectionReasonEnum {
    NOT_ENOUGH_AVAILABILITY = 'not_enough_availability',
    PROVIDER_DOES_NOT_MEET_CRITERIA = 'provider_does_not_meet_criteria',
    THE_NEED_HAS_BEEN_FILLED_BY_ANOTHER_PROVIDER = 'the_need_has_been_filled_by_another_provider',
    RATE_IS_TOO_HIGH = 'rate_is_too_high',
    OTHER = 'other',
}
